import React, { useEffect, useState } from "react";
import "./pageStyles.scss";
import {
  Button,
  Drawer,
  Grid,
  InputAdornment,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import Search from "@material-ui/icons/Search";
import DMModal from "../components/common/controls/DMModal";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import AntSwitch from "../components/common/controls/AntSwitch";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import DMModelSelect from "../components/common/DMModelSelect";
import { sortViewService } from "../services/ViewsService";
import * as miscAction from "../actions/miscAction";
import * as viewsAction from "../actions/viewsAction";
import * as dataDescriptionAction from "../actions/dataDescriptionAction";

import * as modelAction from "../actions/modelAction";
import { connect } from "react-redux";
import Loading from "../components/Loading/Loading";
import WarningPopup from "../components/common/controls/warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../constants/constants";
import ConfigureMsgDetails from "./ConfigureMsgDetails";
import {
  deleteMsgConfigService,
  getMsgConfigsService,
} from "../services/ConfigMsgService";

var CONTROLS_DATA = require("./ControlsData.json");
var CONFIG_CONTROLS = CONTROLS_DATA.SCREENS.CONFIG_MSG;

const ConfigureMsg = ({
  viewsState,
  miscState,
  getViews,
  getDataDescriptions,
  createNewView,
  deleteView,
  setSnackBar,
  UpdateView,
  onPageSelected,
  intl,
  fullLangCode,
}) => {
  // const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState();
  const [showNewView, setShowNewView] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedView, setSelectedView] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [newView, setNewView] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [pageSize, setPageSize] = useState(10);

  const onNewViewClick = () => setShowNewView(true);

  const [views, setViews] = useState([]);

  const getConfigMsgList = async () => {
    await getMsgConfigsService(miscState?.selectedModel)
      .then((res) => {
        console.log("res: ", res.data);
       
        const tempData = res?.data?.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });

        setViews(
          tempData.map((ele) => {
            return { ...ele, name: ele.messageName };
          })
        );
      })
      .catch((err) => {
        const { status, data } = err?.response;
        if (status !== 404 && !data.includes("No messages found")) {
          setSnackBar(
            true,
            "error",
            injectIntlTranslation(
              intl,
              "errorFetchConfigMsgList",
              constants.errorFetchConfigMsgList
            )
          );
        }
        setViews([]);
        console.log(err?.response);
      });
  };

  const onDelete = (viewName) => {
    setShowDelete(viewName);
  };

  useEffect(() => {
    getViews(miscState?.selectedModel);
    getDataDescriptions(miscState?.selectedModel);
    getConfigMsgList();
  }, [miscState?.selectedModel]);

  useEffect(() => {
    const ctrlData = [];
    if (searchValue.length > 0) {
      onPageSelected(0);
    }
    const filteredViews = views?.filter((e) =>
      e.name.toLowerCase().includes(searchValue)
    );
    filteredViews.forEach((view) => {
      ctrlData.push({
        rowId: view.name,
        highlight: view.name ? "" : "highlight",
        viewId: view.name,
        rowKey: view.name,
        sort: view?.sort,
        rowValue: [
          // {
          //   colType: "contained-label",
          //   colOptions: {
          //     width: "200px",
          //     value: view.name,
          //     tab: "config-msg",
          //     view: view,
          //     onUpdate: () => {},
          //     fullLangCode: fullLangCode,
          //     disabled: true
          //   },
          // },
          {
            colType: "custom-component",
            component: () => {
              return (
                <Tooltip title={view.name || "-"} arrow>
                  <div
                    style={{
                      background: "rgb(230 243 253)",
                      padding: "10px 5px",
                      color: "#617080",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "90%",
                    }}
                  >
                    {view.name || "-"}
                  </div>
                </Tooltip>
              );
            },
            colOptions: {
              value: view.name,
              model: view,
            },
          },
          {
            colType: "custom-component",
            component: () => {
              return (
                <>
                  {injectIntlTranslation(
                    intl,
                    view.messageType,
                    view.messageType
                  )}
                </>
              );
            },
            colOptions: {
              value: view.messageType,
              model: view,
            },
          },
          {
            colType: "custom-component",
            component: () => {
              return (
                <Tooltip title={view.messageContent || "-"} arrow>
                  <div
                    style={{
                      background: "rgb(230 243 253)",
                      padding: "10px 5px",
                      color: "#617080",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "96%",
                    }}
                  >
                    {view.messageContent || "-"}
                  </div>
                </Tooltip>
              );
            },
            colOptions: {
              value: view.messageContent,
              model: view,
            },
          },
          // {
          //   colType: "grid-select",
          //   colOptions: {
          //     tab: "config-msg",
          //     model: null,
          //     searchPlaceHolderText: "Search for a Region",
          //     selectInfoText: "Select a Region",
          //     selectedValue: view.messageType,
          //     width: "100px",
          //     menuList: [],
          //     textWidth: "100px",
          //     popperWidth: "211px",
          //     popperHeight: "324px",
          //     onUpdate: () => {},
          //     onChange: () => {},
          //   },
          // },
          // {
          //   colType: "contained-label",
          //   colOptions: {
          //     width: "100%",
          //     fullWidth: true,
          //     value: view.messageContent,
          //     tab: "config-msg",
          //     view: view,
          //     onUpdate: () => {},
          //     fullLangCode: fullLangCode,
          //     disabled: true,
          //   },
          // },
          {
            colType: "grid-actions",
            colOptions: [
              {
                name: "editmsg",
                tab: "config-msg",
                action: () => setDrawerOpen(view),
              },
              { name: "delete", action: () => onDelete(view) },
            ],
          },
        ],
      });
    });
    setGridData([...ctrlData.sort((a, b) => a.sort - b.sort)]);
    // setViews(views);
  }, [views, searchValue, sortBy, fullLangCode]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      minWidth: 222,
      "& .MuiSelect-root": {
        padding: "10px",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "23% 20% 50% 7%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  useEffect(() => {
    setIsDisabled(!(newView && newView?.viewName?.length > 0));
  }, [newView]);

  const onSelectedPage = (selectedPage) => onPageSelected(selectedPage);
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    setPageSize(gridData.length);
    setShowTable(false);
  }, [gridData]);

  useEffect(() => {
    if (!showTable) {
      // console.log(pageSize)
      setShowTable(true);
    }
  }, [showTable]);

  const newMsgClick = () => {
    setDrawerOpen(true);
  };

  const deleteConfigureMsg = async () => {
    const { messageId = "" } = showDelete;
    if (messageId) {
      setLoading(true);
      await deleteMsgConfigService(messageId)
        .then((res) => {
          getConfigMsgList();
          setSnackBar(
            true,
            "success",
            injectIntlTranslation(
              intl,
              "msgDeleteSuccess",
              constants.msgDeleteSuccess
            )
          );
        })
        .catch((err) => {
          setSnackBar(
            true,
            "error",
            injectIntlTranslation(
              intl,
              "msgDeleteError",
              constants.msgDeleteError
            )
          );
        })
        .finally(() => {
          setLoading(false);
          setShowDelete(false);
        });
    }
  };

  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  return (
    <div container className="page-container content-center views-page">
      <Grid container xs={12} md={9} className="page-content">
        <Grid container item xs={12} md={5} className="page-menu">
          <DMModelSelect />
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          className="page-menu"
          justify="flex-end"
        >
          <Grid item container xs={12} md={2} justify="center"></Grid>

          <Grid item container xs={12} md={6} justify="flex-end">
            <TextField
              id="search"
              placeholder={injectIntlTranslation(
                intl,
                "searchPlacholder",
                constants.searchPlacholder
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleSearch(e.target.value)}
              autoComplete={"off"}
              style={{
                borderBottom: "1px solid #617080",
                height: "30px",
                marginTop: "5px",
                width: "230px",
              }}
            />
          </Grid>
          <Grid item container xs={12} md={4} justify="flex-end">
            <CustomButton
              id="newView"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name={injectIntlTranslation(
                intl,
                "newMsgBtn",
                constants.newMsgBtn
              )}
              onClick={newMsgClick}
            />
          </Grid>
        </Grid>
        {gridData.length > 0 && showTable && (
          <DMGrid
            headers={CONFIG_CONTROLS.GRID_HEADERS}
            headerClassName={classes.gridHeaderColumns}
            data={gridData}
            draggable={true}
            tab="views"
            selectedPage={viewsState.selectedPage}
            onPageSelection={onSelectedPage}
            setGridData={(t) => {
              setGridData(t);
            }}
          />
        )}

        {gridData.length === 0 && showTable && (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "150px",
              opacity: "0.6",
            }}
          >
            {injectIntlTranslation(intl, "noMsgData", constants.noMsgData)}
          </div>
        )}

        {/* <WarningPopup
          open={showDelete}
          onClose={() => setShowDelete(false)}
          title={injectIntlTranslation(
            intl,
            "modelDeleteTitle",
            constants.modelDeleteTitle
          )}
          description={injectIntlTranslation(
            intl,
            "deleteViewWarningContent",
            constants.deleteViewWarningContent
          )}
          saveButtonLabel={`${injectIntlTranslation(
            intl,
            "deleteBtnLabel",
            constants.deleteBtnLabel
          )}`}
          onSave={() => {
            deleteConfirm(selectedView);
          }}
        /> */}
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Loading open={loading} />
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
        }}
      >
        <ConfigureMsgDetails
          modelId={miscState?.selectedModel}
          msgData={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          onSuccess={(isUpdate = false) => {
            getConfigMsgList();
            setSnackBar(
              true,
              "success",
              isUpdate
                ? injectIntlTranslation(
                    intl,
                    "msgUpdateSuccess",
                    constants.msgUpdateSuccess
                  )
                : injectIntlTranslation(
                    intl,
                    "msgCreateSuccess",
                    constants.msgCreateSuccess
                  )
            );
          }}
          setSnackBar={setSnackBar}
        />
      </Drawer>
      <WarningPopup
        open={showDelete}
        onClose={() => setShowDelete(false)}
        title={injectIntlTranslation(
          intl,
          "modelDeleteTitle",
          constants.modelDeleteTitle
        )}
        description={injectIntlTranslation(
          intl,
          "deleteConfigMsgWarningContent",
          constants.deleteConfigMsgWarningContent
        )}
        saveButtonLabel={`${injectIntlTranslation(
          intl,
          "deleteBtnLabel",
          constants.deleteBtnLabel
        )}`}
        onSave={() => {
          deleteConfigureMsg();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  miscState: state.misc,
  viewsState: state.views,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getViews: async (requestPayload) =>
      dispatch(viewsAction.getViews(requestPayload)),
    createNewView: async (requestPayload) =>
      dispatch(viewsAction.createNewView(requestPayload)),
    UpdateView: async (requestPayload) =>
      dispatch(viewsAction.UpdateView(requestPayload)),
    deleteView: async (requestPayload) =>
      dispatch(viewsAction.deleteView(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(viewsAction.setViewSelectedPage(selectedPage)),
    getDataDescriptions: async (requestPayload) =>
      dispatch(dataDescriptionAction.getDataDescriptions(requestPayload)),
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ConfigureMsg)
);
